export class ChangeUserPassword {
  userId: number;
  currentPassword: string;
  newPassword: string;
  repeatNewPassword: string;
  sendInfoToServer: boolean;
}
